import { render, staticRenderFns } from "./PermissionCheckbox.vue?vue&type=template&id=1f0c7709"
import script from "./PermissionCheckbox.vue?vue&type=script&lang=ts"
export * from "./PermissionCheckbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports